<template>
  <div class="billings">
    <!-- <div class="billings-add" v-if="!existBilling">
      <span>No tienes facturaciones agregadas</span>
      <button @click="newBilling()" class="btn btn-outline-primary rounded-50" type="button">
        Agregar facturación
      </button>
    </div>
    <div
      class="row align-items-center justify-content-between"
      v-if="existBilling && !showLoadingJoinnus"
    >
      <div class="billings-title">
        <h6>Seleccionar una facturación</h6>
        <button @click="newBilling()" class="btn btn-outline-primary rounded-50" type="button">
          Agregar
        </button>
      </div>
      <div class="col-12 mt-3">
        <div v-for="i in billings" :key="i.id">
          <div class="checkbox-address mb-2">
            <b-form-checkbox
              :id="`checkbox-${i.id}`"
              v-model="i.selected"
              @change="selectBilling(i)"
            >
            </b-form-checkbox>
            <div
              class="card shadow-sm"
              :style="i.selected ? 'border: 1px solid #28a745;' : 'border: 1px solid #ced4da;'"
              @click="selectBilling(i)"
            >
              <div class="form-row align-items-center p-2">
                <div class="col-auto">
                  <i class="fas fa-lg fa-map-marker-alt p-2"></i>
                </div>
                <div class="col">
                  <h6>
                    {{ `${i.businessIdentifier} - ${i.businessName}` }}
                  </h6>
                  <div class="small">
                    {{ showDepartament(i) }}
                  </div>
                </div>
                <div class="col-auto">
                  <button @click.prevent="editBilling(i)" type="button" class="btn btn-link btn-sm">
                    <i class="material-icons">edit</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <ModalBilling></ModalBilling>
  </div>
</template>
<script>
export default {
  name: 'UserDataBuyBilling',
  data() {
    return {};
  },
  computed: {
    billings() {
      return this.$store.state.billing.billings;
    },
    existBilling() {
      return this.billings.length > 0 ? true : false;
    },
    showLoadingJoinnus() {
      return this.$store.state.loadingJoinnus;
    }
  },
  methods: {
    showDepartament(value) {
      const { address, addressDistrict, addressProvince, addressDepartment } = value;
      if ((addressDistrict && addressProvince, addressDepartment)) {
        return `${address}, ${addressDistrict}, ${addressProvince} ${addressDepartment}.`;
      } else {
        return `${address}`;
      }
    },
    selectBilling(item) {
      let billing = { ...item };
      this.$store.dispatch('selectedBillings', billing);
      if (item.selected) {
        this.$store.dispatch('setBilling', billing);
      } else {
        this.$store.dispatch('resetFormBilling');
      }
    },
    newBilling() {
      this.$store.dispatch('resetFormBilling');
      this.$store.dispatch('changeShowModalBilling', true);
      this.$store.dispatch('changeTypeModalBilling', 'ADD');
    },
    editBilling(value) {
      this.$store.dispatch('setBilling', value);
      this.$store.dispatch('changeShowModalBilling', true);
      this.$store.dispatch('changeTypeModalBilling', 'EDIT');
    }
  }
};
</script>
<style lang="scss">
.form-control.is-valid,
.form-control.is-invalid {
  background: none;
}

.is-invalid {
  border-color: #dc3545;
}

.is-valid {
  border-color: #28a745;
}
.billings {
  &-add {
    border: 1px dashed grey;
    display: flex;
    flex-direction: column;
    border-radius: 18px;
    min-height: 150px;
    justify-content: center;
    align-items: center;
    align-content: center;
    span {
      margin-bottom: 1rem;
      font-weight: bold;
    }
  }
  &-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    align-content: center;
    flex-wrap: nowrap;
    width: 100%;
    padding: 1rem;
  }
}

.checkbox-address {
  display: flex;
  align-items: center;
  width: 100%;

  .card {
    width: 100%;
    cursor: pointer;
  }
}
.border-selected {
  border: 1px solid #28a745 !important;
}
.default {
  border: 1px solid #ced4da !important;
}
</style>